import React, { Component } from 'react';
import axios from 'axios'
import QS from 'querystring'
import { URL_API_COLLABORATOR } from '../Utils';

export const saveRow = (row, cb) => {
    axios.put(`${URL_API_COLLABORATOR}?${QS.stringify(row)}`).then(res => {
        if(cb) cb({saveStatus: 'success'}, row.id)
    }).catch(function (error) {
        if(cb) cb({saveStatus: 'fail'}, row.id)
    })
}

export default class SaveCollaborator extends Component {
    constructor(props) {
        super(props);
        this.updateStatus.bind(this);
        this.state = {
            selectedRow: null,
            saveStatus: props.saveStatus
        };
    }

    componentWillReceiveProps(nextProps) {
        // alert('@ SaveCollaborator.componentWillReceiveProps')
        this.setState(nextProps)
    }

    updateStatus(newStatus) {
        this.setState(newStatus)
    }

    render() {
        return (
            <div>
                <button onClick = { () => saveRow(this.props.row, this.updateStatus) } className={ this.state.saveStatus==='success' ? "btn btn-success" : this.state.saveStatus==='fail' ? "btn btn-danger" : "btn btn-default"}><i className="glyphicon glyphicon-ok"></i></button>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/SaveCollaborator.js